import Density from "./Density";
import OperationMode from "./OperationMode";
import styles from './style.module.scss';

const OperationSettingPage = () => {

    return <div className="m-header bgPage">
        <div className='header-page'>
            <div className='title-page'>
                <b>Operation</b>
            </div>
        </div>
        <div className='body-page pt-10' data-box='true'>
            <div className={styles.content}>
                <Density />
                <OperationMode />
                {/* <TemperatureColumnChart /> */}
            </div>
        </div>
    </div>;
}

export default OperationSettingPage;